import React from 'react'
import {withStyles} from 'material-ui/styles'

const styles = theme => ({
  VBContainer: {
    [theme.breakpoints.up('xs')]: {
      width: '100%',
      maxWidth: 450,
    },
    [theme.breakpoints.up('sm')]: {
      width: 600,
      maxWidth: 'none',
    },
    [theme.breakpoints.up('md')]: {
      width: 800,
    },
    [theme.breakpoints.up('lg')]: {
      width: 1250,
    },
    [theme.breakpoints.up('xl')]: {
      width: 1250,
    },
    width: '100%',
    margin: '0 auto',
    padding: 25,
    boxSizing: 'border-box',
  },
})

const Container = ({classes, children, style}) => {
  return (
    <div className={classes.VBContainer} style={style}>
      {children}
    </div>
  )
}

export default withStyles(styles, {withTheme: true})(Container)



// WEBPACK FOOTER //
// ./src/common/components/Container.js